
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { DisplayedInfo } from '~/interfaces/device.interface';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';

@Component
export default class InfoTooltip extends Mixins(DarkThemeInfoMixin) {
    @Prop() infoToDisplay!: DisplayedInfo[];

    get iconColor(): string {
        if (this.infoToDisplay.some((info) => info.criticality === 'error')) {
            return 'error';
        }
        if (this.infoToDisplay.some((info) => info.criticality === 'warning')) {
            return 'warning';
        }
        return 'success';
    }
}
